import { IconButton, Menu, MenuItem, Stack, useTheme } from "@mui/material";
import { FunnelIcon } from "@phosphor-icons/react/dist/csr/Funnel";
import { useState } from "react";
import { JSX } from "react/jsx-runtime";
import { IconForFilter } from "../../../components/IconForFilter/IconForFilter";
import { CheckboxWithLabel } from "../../../components/ui/CheckboxWithLabel";

type CheckboxFiltersProps<TValue extends string> = {
  options: Array<{
    value: TValue;
    label: string;
  }>;
  selectedOptions?: string[];
  onClickOption: (value: TValue) => void;
  Icon?: JSX.Element;
};

const CheckboxFilters = <TValue extends string>({
  options,
  onClickOption,
  selectedOptions,
  Icon,
}: CheckboxFiltersProps<TValue>) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const theme = useTheme();
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const filterCount = selectedOptions?.length || 0;

  return (
    <>
      {Icon ? (
        <IconButton onClick={handleOpen}>{Icon}</IconButton>
      ) : (
        <IconForFilter
          iconComponent={
            <IconButton onClick={handleOpen} data-testid="quickFilters">
              <FunnelIcon size={24} color={theme.palette.text50.main} />
            </IconButton>
          }
          count={filterCount}
          show={filterCount > 0}
          bottom="23px"
          left="24px"
        />
      )}
      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              borderRadius: "4px",
              padding: "16px 24px 8px",
            },
          },
        }}
      >
        {options.map(({ value, label }) => (
          <MenuItem
            key={value}
            value={value}
            sx={(scopedTheme) => ({
              "&.Mui-selected": {
                backgroundColor: scopedTheme.palette.surfaceLight10.main,
              },

              "&.MuiMenuItem-root": {
                padding: "0 0 8px 0",
              },
            })}
          >
            <Stack spacing="8px" direction="row">
              <CheckboxWithLabel
                color="primary"
                checked={selectedOptions?.includes(value) || false}
                onClick={() => onClickOption(value)}
                label={label}
                checkboxSx={{ marginRight: "8px" }}
              />
            </Stack>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export { CheckboxFilters };
